import {
  FormControlLabel,
  Radio,
  Stack,
  styled,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";

export const OnboardingRadioBtn = ({
  data,
  isChecked,
  onChange,
  disabled = false,
}: {
  data: any;
  disabled?: boolean;
  onChange?: (value: any) => void;
  isChecked?: boolean;
}) => {
  const theme = useTheme();

  const handleClick = () => {
    if (!disabled && onChange) {
      onChange(data.value);
    }
  };

  const handleRadioClick = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  return (
    <Stack
      width="fit-content"
      minWidth={"100px"}
      direction="row"
      alignItems={"center"}
      justifyContent={"space-between"}
      borderRadius="16px"
      border={`1px solid ${
        isChecked ? theme.palette.primary.main : theme.palette.neutral["020"]
      }`}
      bgcolor={
        isChecked ? theme.palette.primary.tint : theme.palette.neutral.main
      }
      sx={{
        gap: "24px",
        cursor: disabled ? "not-allowed" : "pointer",
        p: "6px 0px 6px 16px",
      }}
      onClick={handleClick}
    >
      <Typography variant="body-medium"> {data.label}</Typography>
      <FormControlLabel
        sx={{
          ...theme.typography["body-small"],
          color: theme.palette.lightBg.low,
          gap: "0px",
        }}
        value={data.value}
        label={""}
        control={
          <Radio
            onClick={handleRadioClick}
            checkedIcon={<CustomRadioCheckedIcon />}
            icon={<CustomRadioIcon />}
            disabled={disabled}
            checked={isChecked}
            {...data?.radioButtonProps}
            sx={{
              padding: "0px",
            }}
          />
        }
      />
    </Stack>
  );
};

const CustomRadioIcon = styled("span")(({ theme }) => ({
  borderRadius: "50%",
  width: 20,
  height: 20,
  border: "2px solid #CCCCCC",
  backgroundColor: "#FFFFFF",
  backgroundImage:
    "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
  "input:disabled ~ &": {
    boxShadow: "none",
    background: "rgba(206,217,224,.5)",
  },
}));

const CustomRadioCheckedIcon = styled(CustomRadioIcon)({
  backgroundColor: "#FFFFFF",
  border: "6px solid #5563F5",
  backgroundImage:
    "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
  "&:before": {
    display: "block",
    backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
    content: "''",
  },
});
